/* eslint-disable max-lines */
import {
  getFilterChipLabelMap,
  DEFAULT_TABLE_COLUMNS,
  getV3PayloadFromSearch
} from './branches.service';
import { getColumns, getBranchesSnapshotData } from './branches.table.service';
import { getContributorAvatarUrl } from 'common/constants/Avatars';
import {
  ARTICLE_IDS,
  DD_LOGS_CONSTS,
  SEARCH_DATE_FORMAT,
  TRACKING
} from 'common/constants/constants';
import {
  callBranchesCount,
  getBranchesSnapshots
} from 'common/services/branches.service';
import { isSelectedTeamParentSelector } from 'state/selectors/teams';
import { selectedTeamFlatContributorsSelector } from 'state/selectors/contributors';
import {
  extractFromQueryString,
  getMinDateForDatePicker,
  navigateBookDemoClick
} from 'common/utils/utils';
import GridChipFilterContainer from 'components/GridChipFilterContainer/GridChipFilterContainer';
import { createTeamIdFilterConfig } from 'components/GridChipFilterContainer/common-filters';
import {
  convertSearchToRequest,
  handleSearchParams,
  trackSearch,
  AUTOCOMPLETE_TYPES
} from 'components/GridChipFilterContainer/helpers';
import debounce from 'debounce-promise';
import get from 'lodash/get';
import intersection from 'lodash/intersection';
import capitalize from 'lodash/capitalize';
import ldDebounce from 'lodash/debounce';
import moment from 'moment';
import QueryString from 'query-string';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getServicesSelector } from 'state/selectors/services';
import { metricNames } from '@linearb/linjs-common';
import { useHistory, useLocation } from 'react-router-dom';
import CustomFilterWithCTA from '../../../../../../../../components/customFilter/CustomFilterWithCTA';
import { COMPONENT_TYPE } from 'components/GridChipFilterContainer/consts';
import {
  CTA_TOOLTIP_TEXTS,
  CUSTOM_COMPONENTS_PLACEHOLDERS,
  DORA_DASHBOARD_V2_EVENT_DATES_LIMIT_DAYS,
  TRACKING as TRACKING_EVENTS
} from '../../../dashboard/doraV2/dashboard.doraV2.freeTier.consts';
import useDoraFeatureFlags from 'views/root/views/home/hooks/useDoraFeatureFlags';
import * as TrackingService from 'common/services/tracking.service';
import { usePullRequestLabels } from 'common/fetchHooks/usePullRequestLabels';
import { getMetricsV3 } from 'common/services/metrics.service';
import { DEFAULT_TIME_RANGE_KEY } from 'common/constants/metrics';
import { shouldChangeV3BasedBranches } from '../../activity.utils';
import { repositoriesByIdSelector } from 'state/selectors/repositories';
import { useSettings } from './useSettings';
import { lightColorPalette } from '@linearb/linui-common';
import { useDefaultDateRange } from '../../useDefaultDateRange';
import useTeamGitFilters from '../../hooks/useTeamGitFilters';

const highRiskLabel = 'High Risk Work';
const highReworkLabel = 'High Rework Rate';

// eslint-disable-next-line max-lines-per-function
const Branches = ({
  getBranchesV2,
  repositories = [],
  branchesV2,
  contributorsById,
  latestIterationEndDate,
  latestIteration,
  oneBeforeLatestOrLatestIteration,
  currentTeams = [],
  selectedTeam,
  isTeamLicense,
  selectedTeamContributors,
  gitIntegrations,
  myAccount,
  license,
  toggleModal,
  toggleSnackBar,
  clearBranchesV2
}) => {
  const location = useLocation();
  const history = useHistory();
  const teamId = get(selectedTeam, 'id', '');
  const {
    releaseStages,
    fetchBranchesActivityFiltersCountEnabled,
    excludeBranchFromCycleTimeFF,
    isCycleTimeInspectionEnabled,
    isShowPRLabelsFilterEnabled,
    servicesTabEnabledFF,
    codeChangesMediumTopRange,
    codeChangesSmallTopRange,
    highRiskNewWork,
    highRiskPrSize,
    isHideNonWorkingDaysEnabled,
    newWorkMediumTopRange,
    newWorkSmallTopRange,
    showPersonalInformation,
    branchMetricsPerPrIssuerEnabled
  } = useSettings(teamId);

  const { from, to } = useDefaultDateRange();
  const search = QueryString.parse(location.search);

  const [initialSearch] = useState(search);
  const [loadingBranches, setLoadingBranches] = useState(false);
  const [loadingData, setLoadingData] = useState(false);

  const { pullRequestLabels } = usePullRequestLabels();
  const [branchesCycleTimeStages, setBranchesCycleTimeStages] = useState({});
  const [tableRefreshTimestamp, setTableRefreshTimestamp] = useState(null);
  const contributors = useSelector(selectedTeamFlatContributorsSelector) || [];
  const repositoriesByIds = useSelector(repositoriesByIdSelector);
  const services = useSelector(getServicesSelector);
  const isSelectedTeamParent = useSelector(isSelectedTeamParentSelector);
  const [branchesSummary, setBranchesSummary] = useState<any>({});
  useEffect(() => {
    clearBranchesV2();
  }, []);

  const customStagesList = releaseStages || [];
  const customStages = customStagesList.length
    ? customStagesList.concat({
        description: 'Time To Release',
        metric_name: metricNames.BRANCH_TIME_TO_RELEASE
      })
    : [];
  const [isCycleTimeColsExpanded, setIsCycleTimeColsExpanded] = useState(false);
  const [isWorkBreakdownColsExpanded, setIsWorkBreakdownColsExpanded] =
    useState(false);
  const [predefinedFilterSums, setPredefinedFilterSums] = useState({});
  const [allBranchesIds, setAllBranchesIds] = useState(null);

  const [isBasedOnV3Branches, setIsBasedOnV3Branches] = useState(
    !!search.metric_name
  );
  useTeamGitFilters();

  const reloadBranchesData = () => {
    const now = new Date().toString();
    setTableRefreshTimestamp(now);
  };

  const toggleIsCycleTimeColsExpanded = () =>
    setIsCycleTimeColsExpanded(value => !value);
  const toggleIsWorkBreakdownColsExpanded = () =>
    setIsWorkBreakdownColsExpanded(value => !value);

  const initialColsExpandedValues = () => {
    setIsCycleTimeColsExpanded(
      get(
        location,
        'state.isCycleTimeColsExpanded',
        Boolean(JSON.parse((search?.isCycleTimeColsExpanded as string) || null))
      )
    );
    setIsWorkBreakdownColsExpanded(
      get(
        location,
        'state.isWorkBreakdownColsExpanded',
        Boolean(
          JSON.parse((search?.isWorkBreakdownColsExpanded as string) || null)
        )
      )
    );
  };

  useEffect(() => {
    initialColsExpandedValues();
  }, []);

  const { enableTeamSelection, isAllControbutorsTeamSelected } =
    useDoraFeatureFlags();

  const getBranchesIdsFromV3 = useCallback(async () => {
    try {
      const { metric_name, selected_ids } = search;
      const selectedIdsArr = (selected_ids as string)?.split(',');
      setLoadingBranches(true);
      setAllBranchesIds(null);

      const data = await getMetricsV3(getV3PayloadFromSearch(search));

      const branches =
        get(data, ['0', 'data', '0', `${metric_name}:raw`])?.filter(
          item =>
            !selectedIdsArr ||
            selectedIdsArr.includes(item.branch_id.toString())
        ) || [];

      const branchIds = branches.map(item => item.branch_id);
      setBranchesCycleTimeStages(
        isCycleTimeInspectionEnabled
          ? branches.reduce((acc, current) => {
              acc[current.branch_id] = current.metric_names;
              return acc;
            }, {})
          : {}
      );

      setAllBranchesIds(branchIds || []);
      if (branchIds?.length) {
        setLoadingData(true);
      }

      return branchIds;
    } catch (exp) {
      setAllBranchesIds([]);
      return [];
    } finally {
      setLoadingBranches(false);
    }
  }, [search]);

  const selectedTeamParams = selectedTeam
    ? { filtered_teams: selectedTeam.id.toString() }
    : {};
  const showTeamIdFilters =
    (!selectedTeam || isSelectedTeamParent) && !isTeamLicense;

  const navigateAndTrackBookDemo = () => {
    TrackingService.logEvent(TRACKING.EVENTS.CTA_CLICK, {
      page: TRACKING.PAGES.ACTIVITY,
      tab: TRACKING.PAGE_TABS.BRANCHES,
      cta: TRACKING_EVENTS.CTA_TYPE.FILTERS,
      intent: TRACKING.CTA_INTENT.BOOK_A_DEMO,
      source_url: window.location.href
    });
    navigateBookDemoClick();
  };

  const filtersConfig = {
    WIP: {
      articleId: ARTICLE_IDS.WIP,
      subTitle: 'Active branches',
      amplitudeClickType: TRACKING.CLICK.PREDEFINED_WIP,
      searchState: {
        order_by: 'updated_at,desc',
        'Branch State': 'active',
        cycle_time_updated: `${from},${to}`,
        ...selectedTeamParams
      }
    },
    Done: {
      articleId: ARTICLE_IDS.DONE_IN_ITERATION,
      subTitle: `In ${capitalize(latestIteration.name)}`,
      amplitudeClickType: TRACKING.CLICK.PREDEFINED_DONE,
      searchState: {
        pit: moment(latestIterationEndDate).format(SEARCH_DATE_FORMAT),
        'Branch State': 'merged,deployed',
        updated: `${latestIteration.start_date},${latestIteration.end_date}`,
        order_by: 'updated_at,desc',
        ...selectedTeamParams
      }
    },
    ...(!!oneBeforeLatestOrLatestIteration
      ? {
          Carryover: {
            value: false,
            subTitle: `from ${oneBeforeLatestOrLatestIteration.name}`,
            amplitudeClickType: TRACKING.CLICK.PREDEFINED_CARRYOVER,
            articleId: ARTICLE_IDS.CARRYOVER,
            searchState: {
              'Branch State': 'active',
              pit: moment(oneBeforeLatestOrLatestIteration.end_date).format(
                SEARCH_DATE_FORMAT
              ),
              ...selectedTeamParams
            }
          }
        }
      : {}),
    [highRiskLabel]: {
      value: false,
      subTitle: `In ${capitalize(latestIteration.name)}`,
      amplitudeClickType: TRACKING.CLICK.PREDEFINED_HIGH_RISK,
      articleId: ARTICLE_IDS.HIGH_RISK,
      searchState: {
        order_by: `code_changes,desc`,
        updated: `${latestIteration.start_date},${latestIteration.end_date}`,
        'PR Size': `>${highRiskPrSize}`,
        new_work: `${0}-${highRiskNewWork}`,
        ...selectedTeamParams
      }
    },
    [highReworkLabel]: {
      value: false,
      subTitle: `In ${capitalize(latestIteration.name)}`,
      amplitudeClickType: TRACKING.CLICK.PREDEFINED_HIGH_REWORK,
      articleId: ARTICLE_IDS.HIGH_REWROK,
      searchState: {
        order_by: `code_changes,desc`,
        'PR Size': `>${codeChangesMediumTopRange}`,
        rework: '>30',
        updated: `${latestIteration.start_date},${latestIteration.end_date}`,
        ...selectedTeamParams
      }
    },
    contributors: {
      type: 'multi-autocomplete',
      reqKey: 'contributor_ids',
      options: isTeamLicense ? selectedTeamContributors : contributors,
      getAvatar: ({ name, extended_data, id }) => ({
        url: getContributorAvatarUrl({ id, extended_data }),
        name
      }),
      removeFromSearchParamsFn: ({ values, options }) =>
        intersection(options, values)
    },
    repositories: {
      type: 'multi-autocomplete',
      reqKey: 'repository_ids',
      options: repositories
    },
    services: {
      type: 'multi-autocomplete',
      reqKey: 'service_ids',
      options: services
    },
    filtered_teams: createTeamIdFilterConfig(
      'multi-tree-dropdown',
      currentTeams,
      history,
      location
    ),
    branch_ids: {
      type: 'multi-checkbox',
      reqKey: 'branch_ids',
      options: []
    },
    merged_or_released: {
      type: 'date',
      reqKey: 'merged_or_released'
    },
    ...[
      'cycle_time_updated',
      'updated',
      'created',
      'released',
      'coding_ended',
      'reviewed',
      'merged',
      ...(branchMetricsPerPrIssuerEnabled ? [] : ['committed']),
      DEFAULT_TIME_RANGE_KEY
    ].reduce(
      (acc, key) => ({
        ...acc,
        [key]: {
          type: 'date',
          reqKey: `${key}_at`,
          maxDate: () => extractFromQueryString('pit', null, location.search),
          minDate: () =>
            isAllControbutorsTeamSelected
              ? moment().subtract(
                  DORA_DASHBOARD_V2_EVENT_DATES_LIMIT_DAYS,
                  'days'
                )
              : getMinDateForDatePicker(license)
        }
      }),
      {}
    ),
    order_by: {
      type: 'order_by',
      reqKey: 'order_by'
    },
    'Branch State': {
      type: 'multi-checkbox',
      reqKey: 'branch_states',
      options: ['active', 'stale', 'merged', 'deployed', 'deleted']
    },
    'PR State': {
      type: 'multi-checkbox',
      options: [
        'has-no-pr',
        'initiated',
        'in-review',
        'merged',
        { key: 'draft', denyOthers: true }
      ].filter(Boolean),
      searchValueTransformFn: query => {
        if (query.split(',').find(s => s.toLowerCase() === 'draft')) {
          return { pr_is_draft: true };
        }
        return { pr_states: query.split(','), pr_is_draft: false };
      }
    },
    'PR next State': {
      type: 'multi-checkbox',
      options: [
        'has-no-pr',
        'initiated',
        'in-review',
        'merged',
        { key: 'draft', denyOthers: true }
      ].filter(Boolean),
      searchValueTransformFn: query => {
        if (query.split(',').find(s => s.toLowerCase() === 'draft')) {
          return { is_draft: true };
        }
        return { pr_states: query.split(','), is_draft: false };
      }
    },
    rework: {
      type: 'radio',
      reqKey: 'rework_percentage',
      options: [
        { value: '0-10', label: 'Small - 0-10%' },
        { value: '10-30', label: 'Medium - 10%-30%' },
        { value: '>30', label: 'Large - 30%+' }
      ]
    },
    new_work: {
      type: 'radio',
      reqKey: 'new_work_percentage',
      options: [
        {
          value: `0-${newWorkSmallTopRange}`,
          label: `Small 0-${newWorkSmallTopRange}%`
        },
        {
          value: `${newWorkSmallTopRange}-${newWorkMediumTopRange}`,
          label: `Medium ${newWorkSmallTopRange}%-${newWorkMediumTopRange}%`
        },
        {
          value: `>${newWorkMediumTopRange}`,
          label: `Large - ${newWorkMediumTopRange}%+`
        }
      ]
    },
    refactor: {
      type: 'radio',
      reqKey: 'refactor_percentage',
      options: [
        { value: '0-10', label: 'Small - 0-10%' },
        { value: '10-30', label: 'Medium - 10%-30%' },
        { value: '>30', label: 'Large - 30%+' }
      ]
    },
    'PR Size': {
      type: 'radio',
      reqKey: 'pr_size',
      options: [
        {
          value: `0-${codeChangesSmallTopRange}`,
          label: `Small 0-${codeChangesSmallTopRange}`
        },
        {
          value: `${codeChangesSmallTopRange}-${codeChangesMediumTopRange}`,
          label: `Medium ${codeChangesSmallTopRange}-${codeChangesMediumTopRange}`
        },
        {
          value: `>${codeChangesMediumTopRange}`,
          label: `Large - ${codeChangesMediumTopRange}+`
        }
      ]
    },
    ...(isShowPRLabelsFilterEnabled
      ? {
          labels: {
            type: 'multi-autocomplete',
            reqKey: 'labels',
            options: pullRequestLabels.map(label => ({
              name: label,
              id: label
            }))
          }
        }
      : {})
  };

  const additionalFiltersGroupMap = [
    {
      type: 'checkbox',
      categories: [
        { name: 'Branch State', articleId: ARTICLE_IDS.BRANCH_STATE },
        {
          name: 'PR State',
          articleId: null
        }
      ],
      defaultIsOpen: true,
      title: 'States'
    },
    {
      type: 'date',
      names: [
        'created',
        'updated',
        'coding_ended',
        'reviewed',
        'merged',
        'released',
        'cycle_time_updated',
        'committed'
      ],
      defaultIsOpen: false,
      title: 'Event Dates'
    },
    {
      type: 'radio',
      names: [
        { name: 'rework', label: 'rework' },
        { name: 'refactor', label: 'refactor' },
        { name: 'new_work', label: 'New Work' }
      ],
      defaultIsOpen: false,
      title: 'Work Breakdown',
      articleId: ARTICLE_IDS.WORK_BREAKDOWN
    },
    {
      type: 'radio',
      names: [{ name: 'PR Size', label: '' }],
      defaultIsOpen: false,
      title: 'PR Size'
    }
  ];

  const TABLE_SKELETONS = [
    'avatars-random',
    'singleline-random',
    'singleline-random',
    'singleline',
    'singleline-random',
    'singleline-random',
    'singleline-random',
    'singleline-random',
    'singleline',
    'singleline-random',
    'singleline'
  ];

  useEffect(() => {
    const search = QueryString.parse(location.search);

    if (Object.keys(search).length === 0) {
      Object.assign(search, {}, filtersConfig.WIP.searchState);
    }

    history.replace({
      pathname: location.pathname,
      search: `?${QueryString.stringify(search)}`
    });
  }, []);

  const getBranchesData = async params => {
    setLoadingData(true);

    setBranchesSummary({});

    getBranchesSnapshots({
      ...params,
      fetch_items: false
    })
      .then((data: any) => {
        setBranchesSummary(data.summary);
      })
      .catch(() => {
        setBranchesSummary({});
      });
    await getBranchesV2({ ...params, fetch_summary: false });
    setLoadingData(false);
  };

  const memoizedGetBranchesV2 = useCallback(debounce(getBranchesData, 1000), [
    selectedTeam
  ]);
  const getReqFilterBody = () => {
    const search = QueryString.parse(location.search);
    return {
      ...convertSearchToRequest(search, filtersConfig),
      teams: [selectedTeam?.id]
    };
  };

  const getPredefinedFilterSums = async () => {
    /** Get all the names of the predefined filters */
    const predefinedFilterNames = get(
      filtersGroupMap.find(({ type }) => type === 'predefined'),
      'names',
      []
    ).filter(name => !!get(filtersConfig, `${name}.searchState`, null));

    /** Map each predefined filter name to its request */
    const predefinedFilterRequests = predefinedFilterNames.map(name => {
      const filter = convertSearchToRequest(
        get(filtersConfig, `${name}.searchState`),
        filtersConfig
      );
      return filter;
    });
    /** Fetch all the predefined filters stats and map them by name */
    try {
      if (fetchBranchesActivityFiltersCountEnabled) {
        const counts = await callBranchesCount(predefinedFilterRequests);

        const predefinedFiltersSumsMappedByLabel = predefinedFilterNames.reduce(
          (acc, name, idx) => ({
            ...acc,
            [name]: counts[idx]
          }),
          {}
        );
        setPredefinedFilterSums(predefinedFiltersSumsMappedByLabel);
      } else {
        setPredefinedFilterSums({});
      }
    } catch (e) {
      setPredefinedFilterSums({});
    }
  };

  useEffect(() => {
    const search = QueryString.parse(location.search);

    trackSearch(
      TRACKING.EVENTS.FILTER,
      search,
      ['repositories', 'contributors'],
      TRACKING.PAGES.ACTIVITY,
      TRACKING.PAGE_TABS.BRANCHES
    );
  }, [location.search]);

  const filtersGroupMap = [
    {
      type: 'predefined',
      title: 'PREDEFINED FILTERS',
      page: 'branches',
      itemsWeight: '500',
      defaultIsOpen: true,
      names: [
        'WIP',
        'Done',
        !!oneBeforeLatestOrLatestIteration ? `Carryover` : null,
        highRiskLabel,
        highReworkLabel
      ].filter(Boolean)
    },
    showTeamIdFilters
      ? {
          type: !enableTeamSelection
            ? COMPONENT_TYPE.CUSTOM_FILTER
            : COMPONENT_TYPE.AUTOCOMPLETE_BY_TYPE,
          items: [
            ...(showPersonalInformation
              ? [
                  {
                    type: AUTOCOMPLETE_TYPES.AUTOCOMPLETE,
                    name: 'contributors',
                    title: branchMetricsPerPrIssuerEnabled
                      ? 'Authors'
                      : 'Contributors',
                    addAvatars: true
                  }
                ]
              : []),
            {
              type: AUTOCOMPLETE_TYPES.TREE_TEAMS_DROPDOWN,
              name: 'filtered_teams',
              addAvatars: true,
              multiple: true
            }
          ],
          title: `Teams / ${
            branchMetricsPerPrIssuerEnabled ? 'Authors' : 'Contributors'
          }`,
          defaultIsOpen: true,
          CustomFilter: (
            <>
              <CustomFilterWithCTA
                type={COMPONENT_TYPE.AUTOCOMPLETE}
                ctaButtonText={CTA_TOOLTIP_TEXTS.BOOK_A_DEMO}
                ctaMessage={CTA_TOOLTIP_TEXTS.ACTIVITY_CONTRIBUTORS}
                customComponentProps={{
                  placeholder: branchMetricsPerPrIssuerEnabled
                    ? CUSTOM_COMPONENTS_PLACEHOLDERS.ALL_AUTHOR
                    : CUSTOM_COMPONENTS_PLACEHOLDERS.ALL_CONTRIBUTORS
                }}
                navigateBookDemoClick={navigateAndTrackBookDemo}
              />
              <CustomFilterWithCTA
                type={COMPONENT_TYPE.AUTOCOMPLETE}
                ctaButtonText={CTA_TOOLTIP_TEXTS.BOOK_A_DEMO}
                ctaMessage={CTA_TOOLTIP_TEXTS.ACTIVITY_TEAMS}
                customComponentProps={{
                  placeholder: CUSTOM_COMPONENTS_PLACEHOLDERS.ALL_TEAMS
                }}
                navigateBookDemoClick={navigateAndTrackBookDemo}
              />
            </>
          )
        }
      : showPersonalInformation && {
          type: AUTOCOMPLETE_TYPES.AUTOCOMPLETE,
          items: [{ name: 'contributors', addAvatars: true }],
          title: branchMetricsPerPrIssuerEnabled ? 'Authors' : 'Contributors',
          defaultIsOpen: true
        },
    ...(servicesTabEnabledFF
      ? [
          {
            type: !enableTeamSelection
              ? COMPONENT_TYPE.CUSTOM_FILTER
              : COMPONENT_TYPE.AUTOCOMPLETE,
            items: [
              { name: 'services', defaultIsOpen: false, addAvatars: false }
            ],
            title: 'Services',
            defaultIsOpen: true,
            CustomFilter: (
              <CustomFilterWithCTA
                type={COMPONENT_TYPE.AUTOCOMPLETE}
                ctaButtonText={CTA_TOOLTIP_TEXTS.BOOK_A_DEMO}
                ctaMessage={CTA_TOOLTIP_TEXTS.ACTIVITY_SERVICES}
                customComponentProps={{
                  placeholder: CUSTOM_COMPONENTS_PLACEHOLDERS.ALL_SERVICES
                }}
                navigateBookDemoClick={navigateAndTrackBookDemo}
              />
            )
          }
        ]
      : []),
    {
      type: 'autocomplete',
      items: [
        { name: 'repositories', defaultIsOpen: false, addAvatars: false }
      ],
      title: 'Repositories',
      defaultIsOpen: true
    },
    ...(isShowPRLabelsFilterEnabled
      ? [
          {
            type: 'autocomplete',
            items: [
              {
                name: 'labels',
                title: 'PR labels',
                defaultIsOpen: false,
                addAvatars: false
              }
            ],
            title: 'PR Labels',
            defaultIsOpen: true
          }
        ]
      : [])
  ].filter(Boolean);

  useEffect(() => {
    const searchParams = handleSearchParams({ filtersConfig });

    history.replace({
      pathname: location.pathname,
      search: `?${QueryString.stringify(searchParams)}`
    });

    ldDebounce(getPredefinedFilterSums, 200)();
  }, [selectedTeam]);

  const filterConfigWithBadges = {
    ...filtersConfig,
    ...Object.keys(predefinedFilterSums).reduce(
      (acc, name) => ({
        ...acc,
        [name]: {
          ...filtersConfig[name],
          badge: predefinedFilterSums[name]
        }
      }),
      {}
    )
  };

  useEffect(() => {
    if (shouldChangeV3BasedBranches(initialSearch, location.search)) {
      setIsBasedOnV3Branches(false);
    }
  }, [location.search]);

  const getAdditionalCustomChips = () => {
    if (!isBasedOnV3Branches) {
      return [];
    }
    const top100BranchesChip = {
      label: [
        'Drill-down view',
        ...(allBranchesIds?.length === 100 ? [`(Showing top 100)`] : [])
      ].join(' '),
      size: 'medium',
      color: 'lb',
      textColor: lightColorPalette.lbGreyDark,
      variant: 'outlined',
      onDelete: () => {
        setIsBasedOnV3Branches(false);
        setAllBranchesIds([]);
        history.replace({
          pathname: location.pathname,
          search: `?${QueryString.stringify({
            order_by: 'updated_at,desc',
            'Branch State': 'active',
            ...selectedTeamParams
          })}`
        });
      }
    };
    return [top100BranchesChip];
  };

  const getDataWithV3Handling = async data => {
    if (isBasedOnV3Branches && allBranchesIds === null && !loadingBranches) {
      const currentBranches = await getBranchesIdsFromV3();
      if (!currentBranches?.length) {
        return Promise.resolve();
      }
      data = { ...data, filter: { branch_ids: currentBranches } };
    } else if (isBasedOnV3Branches && allBranchesIds?.length) {
      data = { ...data, filter: { branch_ids: allBranchesIds } };
    } else if (
      isBasedOnV3Branches &&
      (allBranchesIds?.length === 0 || loadingBranches)
    ) {
      return Promise.resolve();
    }

    if (!data?.filter) {
      window.DD_LOGS &&
        window.DD_LOGS.logger.error(DD_LOGS_CONSTS.errors.branchesV2.noFilter, {
          payload: data,
          pathname: location.pathname,
          search,
          account: myAccount
        });
      return Promise.resolve();
    }

    return memoizedGetBranchesV2(data);
  };

  const joinedData = {
    ...branchesV2,
    summary: branchesSummary,
    total: branchesSummary?.total_items
  };

  return (
    <>
      {/* @ts-expect-error */}
      <GridChipFilterContainer
        additionalCustomChips={getAdditionalCustomChips()}
        showOnlyAdditionalChips={isBasedOnV3Branches}
        getData={getDataWithV3Handling}
        loadingInitState={true}
        teamsFilterKey='filtered_teams'
        isExternalLoading={loadingBranches || loadingData}
        data={joinedData}
        tableData={({ onContRepoTableCellClick }) =>
          getBranchesSnapshotData({
            data: branchesV2.items,
            contributorsById,
            repositoriesByIds,
            onRepositoryClick: onContRepoTableCellClick(
              'repositories',
              repositories,
              item => item,
              searchValue =>
                repositories.find(({ http_url }) => http_url === searchValue)
            ),
            onContributorClick: onContRepoTableCellClick(
              'contributors',
              contributors,
              ({ name }) => name
            ),
            repositories,
            gitIntegrations,
            myAccount,
            toggleModal,
            toggleSnackBar,
            isExcludeBranches: excludeBranchFromCycleTimeFF,
            onBranchUpdate: reloadBranchesData,
            isHideNonWorkingDaysEnabled,
            showPersonalInformation,
            branchesCycleTimeStages,
            metricName: search.metric_name,
            isCycleTimeInspectionEnabled,
            customStages
          })
        }
        pageTag={TRACKING.PAGES.ACTIVITY}
        pageTabTag={TRACKING.PAGE_TABS.BRANCHES}
        filterChipLabelMap={getFilterChipLabelMap({
          branchMetricsPerPrIssuerEnabled
        })}
        columns={getColumns({
          branches: joinedData,
          isCycleTimeColsExpanded,
          isWorkBreakdownColsExpanded,
          toggleIsCycleTimeColsExpanded,
          toggleIsWorkBreakdownColsExpanded,
          isExcludeBranches: excludeBranchFromCycleTimeFF,
          branchMetricsPerPrIssuerEnabled,
          customStages
        })}
        defaultColumns={DEFAULT_TABLE_COLUMNS}
        skeletonColumns={TABLE_SKELETONS}
        getReqFilterBody={getReqFilterBody}
        filtersConfig={filterConfigWithBadges}
        filtersGroupMap={filtersGroupMap}
        additionalFiltersGroupMap={additionalFiltersGroupMap}
        refreshOnDependencies={[
          currentTeams,
          selectedTeam,
          tableRefreshTimestamp,
          pullRequestLabels,
          allBranchesIds
        ]}
      />
    </>
  );
};

export default Branches;
